import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import z from "zod"
import type {
  TypedSchemaInput,
  TypedSchemaOutput,
} from "@/utils/typeUtilities"
import {
  requiredTrimmedString,
  trimmedString,
} from "@/forms/validation/stringFieldSchemas"

const categoryFormSchema = z.object({
  name: requiredTrimmedString("Category name is required"),
  parentCategoryId: z.string().uuid().nullable(),
  color: trimmedString().nullable(),
})

export type CategoryFormInput = TypedSchemaInput<
  typeof categoryFormSchema
>

export type CategoryFormOutput = TypedSchemaOutput<
  typeof categoryFormSchema
>

export const useCategoryForm = () =>
  useForm({
    validationSchema: toTypedSchema(categoryFormSchema),
    initialValues: {
      name: "",
      color: null,
      parentCategoryId: null,
    },
  })
